import API from "../api/manager";
import config from "../api/config";

const getNoticeTemplates = (partyId) => {
  return API({
    method: "GET",
    url: config.urls.notice.getNoticeTemplates + `/${partyId}`,
  });
};

const getNoticeTemplate = (templateId) => {
  return API({
    method: "GET",
    url: config.urls.notice.getNoticeTemplate + `/${templateId}`,
  });
};

const bulkNoticeGenerate = (data) => {
  return API({
    method: "POST",
    url: config.urls.notice.bulkNoticeGenerate,
    data,
  });
};

const uploadNoticeTemplates = (data) => {
  return API({
    method: "POST",
    url: config.urls.notice.uploadNoticeTemplates,
    data,
  });
};

const addLetterHeadOption = (data) => {
  return API({
    method: "POST",
    url: config.urls.notice.addLetterHeadOption,
    data,
  });
};

const updateNoticeTemplates = (data, id) => {
  return API({
    method: "PUT",
    url: config.urls.notice.uploadNoticeTemplates + `/${id}`,
    data,
  });
};

const getLetterHeadOption = () => {
  return API({
    method: "GET",
    url: config.urls.notice.getLetterHeadOption,
  });
};

const updateLetterHeadOption = (data, id) => {
  return API({
    method: "PUT",
    url: config.urls.notice.addLetterHeadOption + `/${id}`,
    data,
  });
};

const getNoticeDesign = (partyId) => {
  return API({
    method: "GET",
    url: config.urls.notice.noticeDesign + `/${partyId}`,
  });
};

const updateNoticeDesign = (partyId, data) => {
  return API({
    method: "PUT",
    url: config.urls.notice.noticeDesign + `/${partyId}`,
    data,
  });
};

const updateNoticeOutput = (data) => {
  return API({
    method: "PUT",
    url: config.urls.notice.updateNoticeOutput,
    data,
  });
};

const addNotice = (data) => {
  return API({
    method: "POST",
    url: config.urls.notice.noticeTracking,
    data,
  });
};

const getTrackingList = (query) => {
  return API({
    method: "GET",
    url: config.urls.notice.trackingList + query,
  });
};

const deleteTrackingList = (data) => {
  return API({
    method: "DELETE",
    url: config.urls.notice.trackingList,
    data,
  });
};

const trackingToken = () => {
  return API({
    method: "GET",
    url: config.urls.notice.token,
  });
};

const getTrackingDetails = (data) => {
  return API({
    method: "POST",
    url: config.urls.notice.gettracking,
    data,
  });
};

const deleteNoticeTemplate = (data, id) => {
  return API({
    method: "PUT",
    url: config.urls.notice.uploadNoticeTemplates + `/${id}`,
    data,
  });
};

export default {
  getNoticeTemplates,
  getNoticeTemplate,
  bulkNoticeGenerate,
  uploadNoticeTemplates,
  addLetterHeadOption,
  updateNoticeTemplates,
  getLetterHeadOption,
  updateLetterHeadOption,
  getNoticeDesign,
  updateNoticeDesign,
  updateNoticeOutput,
  addNotice,
  getTrackingList,
  deleteTrackingList,
  trackingToken,
  getTrackingDetails,
  deleteNoticeTemplate,
};
